import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteDb} from '../UserFunctions'
import PropTypes from 'prop-types';


class DeleteCloseLoopScenarioModal extends Component {
    constructor(props){
        super(props)
        console.log(props)
        this.handleDeleteContent = this.handleDeleteContent.bind(this);

        this.state = {
            content: '',
            data : []
        }
    }

    handleDeleteContent() {
        console.log(this.state.content);
        const delete_api_url = (window.location.origin).concat('/close_loop_delete_scenario')
        const data_for_api = {
            uuid : this.props.content
        }
        deleteDb(delete_api_url, data_for_api).then(res => {
            console.log("Status of updation : ", res.status)
            if(res.status === 200){
                // getAllScenarioCloseLoop(dest_url).then(res => {
                //     console.log("close loop scenario view : ",res.data)
                //     this.props.dispatch(updateScenarioDetails(res.data))
                // })
                window.location.reload();
                this.props.handleDeleteModalClose();
                console.log("this.props.data after delete:",this.props)
            }

        })

    }

    componentDidMount() {
        this.setState( (prevState) => {
            if(this.props.content) {
                return {
                    ...prevState,
                    content: this.props.content
                }
            } else {
                return {
                    content: ''
                }
            }
        })
    }

    render() {
        return (
            <Modal isOpen={!!this.props.deleteSelected}>
                <ModalHeader
                    toggle={this.props.handleDeleteModalClose}
                    style={{ color:"#524fa1" }}
                >
                    Delete Scenario 
                </ModalHeader>
                <ModalBody>
                    <div>
                        Are you sure want to delete ?
                    </div>
                </ModalBody>
                <ModalFooter>
                  <button className="btn btn-danger" onClick={this.handleDeleteContent}>Delete</button>
                  <Button className="btn" onClick={this.props.handleDeleteModalClose}>Cancel</Button>

                </ModalFooter>
              </Modal>
        )
    }
}

DeleteCloseLoopScenarioModal.propTypes={
    content:PropTypes.string,
    handleDeleteModalClose:PropTypes.func,
    deleteSelected:PropTypes.number,
}

export default connect()(DeleteCloseLoopScenarioModal);
